import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { AddUserData } from './add-user-data';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddUsersModalService extends BaseModalService<AddUserData> {
  readonly submitStatus$ = new Subject<any>();
  emitSubmitStatus(result: any) {
    this.submitStatus$.next(result);
  }
}
